export default __webpack_public_path__ + "static/media/smartCryptoAssetWallet.2a953a35.svg";